import styled from "styled-components";
import Paragraph from "../typography/Paragraph";

export const StyledSearchText = styled(Paragraph)`
  font-style: normal;
`;

export const StyledSearchTop = styled.div<{ length?: number }>`
  padding: 20px 15px 8px;
  margin-bottom: 0;
  border-bottom: 2px solid
    ${({ length }) => (length === 0 ? "#D8D8D8" : "none")};
`;

export const StyledSearchMiddle = styled.div`
  border-bottom: 2px solid #d8d8d8;
`;

export const StyledSearchBottom = styled.div`
  padding: 23px 15px 40px;
`;

export const StyledMessageText = styled(Paragraph)`
  margin-bottom: 21px;
`;

export const StyledSearchForm = styled.div`
  position: relative;
  font-family: var(--base-font);
  z-index: 5;
`;

export const StyledSearchFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  gap: 10px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const StyledSearchResult = styled.div<{
  resultLength?: number;
  showResults: boolean;
}>`
  position: ${({ showResults }) => (showResults ? "static" : "absolute")};
  left: 0;
  width: 100%;
  overflow: hidden;
  margin-top: ${({ showResults }) => (showResults ? "32px" : "18px")};
  border-radius: 6px;
  background-color: var(--color-white);
  box-shadow: ${({ showResults }) =>
    showResults ? "none" : "0px 4px 30px 10px rgba(0, 0, 0, 0.1)"};
  z-index: 100;
`;

export const StyledNoResult = styled.div<{ resultLength?: number }>``;

export const StyledNoResultAction = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const StyledActionText = styled(Paragraph)`
  margin-top: 15px !important;
  margin-bottom: 0 !important;

  @media (min-width: 768px) {
    margin-left: 10px;
    margin-top: 0 !important;
  }
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 25px;
`;

export const StyledSearchButtonWrapper = styled.div`
  margin-left: 10px;

  @media (max-width: 768px) {
    position: absolute;
    top: 50%;
    right: 2px;
    transform: translateY(-50%);

    > button {
      height: 46px;
    }
  }
`;

export const StyledOverlay = styled.div`
  background: black;
  height: 100%;
  opacity: 0.8;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
